import React from "react"

type As<P = any> = React.ElementType<P>

type Props = {
  children?: React.ReactNode
  as?: As
} & React.CSSProperties

export function CSS({ as: Comp = "div", children, ...style }: Props) {
  return <Comp style={style} children={children} />
}

export function createCssComponent(css: React.CSSProperties, As: As = "div") {
  return ({ as = As, children, ...style }: Props) =>
    CSS({ as, children, ...css, ...style })
}

// short alias
export const ccc = createCssComponent

export function styled(as: As) {
  return (css: React.CSSProperties) => ccc(css, as)
}

/*
type Props = {
  children: React.ReactNode
} & React.CSSProperties &
  ShorthandCSSProperties

type ShorthandCSSProperties = Partial<Record<ShorthandProperties, number>>

type ShorthandProperties = "p" | "pt" | "pr" | "pb" | "pl" | "px" | "py"

function CSS(props: Props) {
  const {
    children,
    p: padding,
    pt: paddingTop,
    pr: paddingRight,
    ...style
  } = props
  const shorthand = { padding }
  return <div style={{ ...shorthand, ...style }} children={children} />
}
*/
